import { useContext } from "react";
import { ThemeColors } from "@src/utility/context/ThemeColors";

export const useTheme = () => useContext(ThemeColors);
